import { BaseClient } from '@/api'

export class TagClient extends BaseClient {
  constructor(
  ) {
    super('tags')
  }
}
